/**
 * Lives in `shared/src/review/dashboard-page-rows.ts`: the Dashboard's page row is built from the
 * `/review` cards, and the PR check reads the same builder. Edit it there.
 *
 * Named rather than `export *`: the Vite dev server's CommonJS interop runs a
 * star re-export before the module it re-exports has loaded.
 */
export {
  DASHBOARD_LINK_MAX_CHIPS,
  DASHBOARD_ROW_BUILDERS,
  DASHBOARD_ROW_MAX_CHIPS,
  REVIEW_CARD_KEYS,
  dashboardPageRows,
  dashboardRowParity,
  reviewCardShown
} from '@taptimize/shared/dist/review/dashboard-page-rows';
export type { DashboardPageRow, ReviewCardKey } from '@taptimize/shared/dist/review/dashboard-page-rows';
